import { useLocalObservable } from 'mobx-react-lite';

import { ICommonPopupsProps } from '@gem/popups';

import { IWorkspaceUser } from 'APP/Tasks/workspace/getWorkspaceUsers';

export interface INewMessagePopupPresenter {
  searchText: string;
  onSearch(searchText: string): void;
  onClose(): void;
  onMemberClick(member: IWorkspaceUser): Promise<void>;
}

export function useNewMessagePopupPresenter(data: ICommonPopupsProps): INewMessagePopupPresenter {
  const { onClose, popupInstance } = data;

  const presenter = useLocalObservable<INewMessagePopupPresenter>(() => ({
    searchText: '',

    onSearch(searchText: string): void {
      this.searchText = searchText;
    },

    onClose(): void {
      popupInstance.close();
      onClose?.();
    },

    async onMemberClick(member: IWorkspaceUser): Promise<void> {
      if (member.user.isMe) {
        return;
      }
      await member.user.startChat();
      presenter.onClose();
    },
  }));

  return presenter;
}
